import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import thunk from 'redux-thunk'
import api from 'src/core/middleware/api'
import { LocalStorageEntity } from 'src/core/localStorage'

import paginateReducer from 'src/core/redux/reducer/generic/paginateReducer'
import ecoWatchReducer from 'src/core/redux/reducer/generic/ecoWatchReducer'
import { IUser } from 'src/type/user'
import { IConsumer } from 'src/type/consumer'
import { StateType } from 'typesafe-actions'
import { IFundraise } from 'src/type/enterprise/fundraise'
import { crudReducer } from './generic/crudReducer'
import { formReducer } from 'src/core/redux/reducer/formReducer'
import { themeReducer } from 'src/core/redux/reducer/themeReducer'
import { modalReducer } from 'src/core/redux/reducer/modalReducer'
import { utilsReducer } from 'src/core/redux/reducer/utilsReducer'
import { crudListReducer } from 'src/core/redux/reducer/generic/crudListReducer'
import { IContextLoanequity } from 'src/type/context-loanequity'
import { accountInfoReducer } from 'src/core/redux/reducer/accountInfoReducer'
import { enterpriseInfoReducer } from 'src/core/redux/reducer/enterpriseInfoReducer'

import { USERS } from 'src/core/redux/action/userAction'
import { FOOTER } from 'src/core/redux/action/seoAction'
import { COTATIONS } from 'src/core/redux/action/cotationsAction'
import { LOANEQUITY } from 'src/core/redux/action/contextLoanequityAction'
import { NEWSLETTER } from 'src/core/redux/action/newsletterAction'
import { FUNDRAISES } from 'src/core/redux/action/fundraiseAction'
import { CATEGORIES } from 'src/core/redux/action/categoriesAction'
import { ENTERPRISE_MEMBERS } from 'src/core/redux/action/enterpriseInfosAction'
import { CONSUMER, CONSUMERS } from 'src/core/redux/action/consumerAction'
import { COTATION, COTATION_COMMENT } from 'src/core/redux/action/cotationAction'
import { SIGNATURES, DOC_TO_SIGN, DOC_NOT_TO_SIGN } from 'src/core/redux/action/signaturesAction'
import { CLOSED_SUBSCRIPTION, OPENED_SUBSCRIPTION, PUBLIC_PRODUCT } from 'src/core/redux/action/publicProductsAction'
import { NEWS, CLOUDS, NEWS_FEATURED, NEWS_PME, NEWS_HEBDO, NEWS_FPP } from 'src/core/redux/action/newsAction'
import { TRANSACTIONS_CHANGE, TRANSACTIONS_DETTE, TRANSACTIONS_PLACEMENT } from 'src/core/redux/action/transactionsAction'
import { PRODUCTS, PRODUCT, PRODUCTS_PLACEMENT, PRODUCTS_DETTE, PRODUCTS_CHANGE } from 'src/core/redux/action/productsAction'

import { IPage } from 'src/type/page'
import { INews } from 'src/type/news'
import { IProduct } from 'src/type/product'
import { ICategory } from 'src/type/category'
import { ISignature } from 'src/type/signature'
import { IPublicProduct } from 'src/type/public-product'
import { ICotation, ICotationComment } from 'src/type/cotation'
import { ITransactionChange, ITransactionDette, ITransactionPlacement } from 'src/type/transaction'

const storage = new LocalStorageEntity('particeep-setup-state')

const persistedState = storage.load() || {}

const rootReducer = combineReducers({
  form: reduxFormReducer,
  formAnswer: formReducer,
  modal: modalReducer,
  accountInfo: accountInfoReducer,
  enterpriseCurrent: enterpriseInfoReducer,
  utils: utilsReducer,
  categories: crudListReducer<ICategory>(CATEGORIES),
  consumers: crudListReducer<IConsumer>(CONSUMERS),
  consumer: crudReducer<IConsumer>(CONSUMER),
  contextLoanEquity: crudReducer<IContextLoanequity>(LOANEQUITY),
  cotation: crudReducer<any>(COTATION),
  newsletter: crudReducer(NEWSLETTER),
  clouds: crudReducer(CLOUDS),
  newsFeatured: crudReducer<INews>(NEWS_FEATURED),
  post: crudReducer<INews>(NEWS),
  productDetail: crudReducer<IProduct>(PRODUCT),
  publicProduct: crudReducer<IPublicProduct>(PUBLIC_PRODUCT),
  footer: crudReducer<IPage>(FOOTER),
  paginate: combineReducers({
    users: paginateReducer<IUser>(USERS),
    fundraises: paginateReducer<IFundraise>(FUNDRAISES),
    news: paginateReducer<INews>(NEWS),
    products: paginateReducer<IProduct>(PRODUCTS),
    signatures: paginateReducer<ISignature>(SIGNATURES),
    docToSign: paginateReducer<ISignature>(DOC_TO_SIGN),
    docNotToSign: paginateReducer<ISignature>(DOC_NOT_TO_SIGN),
    productsChange: paginateReducer<IProduct>(PRODUCTS_CHANGE),
    productsDette: paginateReducer<IProduct>(PRODUCTS_DETTE),
    productsPlacement: paginateReducer<IProduct>(PRODUCTS_PLACEMENT),
    cotations: paginateReducer<ICotation>(COTATIONS),
    transactionsChange: paginateReducer<ITransactionChange>(TRANSACTIONS_CHANGE),
    transactionsDette: paginateReducer<ITransactionDette>(TRANSACTIONS_DETTE),
    transactionsPlacement: paginateReducer<ITransactionPlacement>(TRANSACTIONS_PLACEMENT),
    cotationComment: paginateReducer<ICotationComment>(COTATION_COMMENT),
    enterpriseMembers: paginateReducer<IUser>(ENTERPRISE_MEMBERS),
    closedSubscription: paginateReducer<IPublicProduct>(CLOSED_SUBSCRIPTION),
    openedSubscription: paginateReducer<IPublicProduct>(OPENED_SUBSCRIPTION),
  }),
  ecoWatch: combineReducers({
    newsPME: ecoWatchReducer<INews>(NEWS_PME),
    newsFPP: ecoWatchReducer<INews>(NEWS_FPP),
    newsHEBDO: ecoWatchReducer<INews>(NEWS_HEBDO),
  }),
  ui: combineReducers({
    theme: themeReducer,
  })
})

export type RootState = StateType<typeof rootReducer>;

export const store: Store<RootState> = createStore(
  rootReducer,
  persistedState,
  compose(
    applyMiddleware(thunk, api),
    // Redux DevToops Chrome plugins
    // (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
  )
)

store.subscribe(() => {
  storage.save({
    ui: {
      theme: store.getState().ui.theme
    }
  })
})




// WEBPACK FOOTER //
// ./src/core/redux/reducer/index.ts